import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";

const SizePerPageDropdown = ({ sizePerPage = 10, onChangeSize }) => {
  const [showLonger, setShowLonger] = React.useState(false);

  return (
    <Style>
      <Dropdown isOpen={showLonger} toggle={() => setShowLonger(!showLonger)}>
        <DropdownToggle tag="button" className="btn btn-primary">
          {sizePerPage} <i className="mdi mdi-chevron-down"></i>
        </DropdownToggle>
        <DropdownMenu>
          {[10, 25, 30, 50].map(pageSize => (
            <DropdownItem
              key={pageSize}
              onClick={() => onChangeSize("size", pageSize)}
            >
              <span style={{ color: "#556ee6" }}>{pageSize}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Style>
  );
};

const Style = styled.div`
  margin-top: 10px;
`;

SizePerPageDropdown.propTypes = {
  sizePerPage: PropTypes.any,
  onChangeSize: PropTypes.func,
};

export default SizePerPageDropdown;
